"use strict";

exports.__esModule = true;
exports.prepareClassName = exports.isBrowser = exports.getLocationQueryStringParam = exports.getLocationQS = exports.getLocationPath = exports.generateLocationQueryString = void 0;

var _constants = require("./constants");

const isBrowser = () => typeof window !== 'undefined';

exports.isBrowser = isBrowser;

const getLocationPath = () => isBrowser() ? window.location.pathname : null;

exports.getLocationPath = getLocationPath;

const getLocationQS = () => isBrowser() ? window.location.search : null;

exports.getLocationQS = getLocationQS;

const getLocationQueryStringParam = (param, strategy = _constants.QUERY_STRING_PARAM_STRATEGY.ARRAY) => {
  if (!isBrowser()) {
    return strategy === _constants.QUERY_STRING_PARAM_STRATEGY.STRING ? '' : [];
  }

  const qs = new URLSearchParams(window.location.search);
  const stringValue = decodeURIComponent(qs.get(param) || '');

  if (strategy === _constants.QUERY_STRING_PARAM_STRATEGY.STRING) {
    return stringValue;
  }

  return stringValue ? stringValue.split(',') : [];
};

exports.getLocationQueryStringParam = getLocationQueryStringParam;

const generateLocationQueryString = params => {
  if (!isBrowser()) {
    return '';
  }

  const urlSearchParams = new URLSearchParams(getLocationQS());
  Object.entries(params).forEach(([param, value]) => {
    if (!value.length) {
      urlSearchParams.delete(param);
    } else {
      const paramValue = Array.isArray(value) ? value.map(encodeURIComponent).join(',') : value;
      urlSearchParams.set(param, paramValue);
    }
  });
  const search = urlSearchParams.size ? `?${decodeURIComponent(urlSearchParams.toString())}` : '';
  const path = getLocationPath();
  return `${path}${search}`;
};

exports.generateLocationQueryString = generateLocationQueryString;

const prepareClassName = name => String(name).replace(/\s/g, '-').toLowerCase();

exports.prepareClassName = prepareClassName;